import { OktaAuth } from '@okta/okta-auth-js';
import configData from '../config.json';

export const oktaAuth = new OktaAuth({
  issuer: configData.issuerUrl,
  clientId: configData.oktaClientID,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'], 
  pkce: true,
});